import { faLocationDot } from "@fortawesome/pro-solid-svg-icons"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { GEO_TARGETS_FILE_IMPORT_POPUP_MAX_WIDTH, IGeoTargetsFileImport } from "form/model"
import { getGeoTargetsFileImport, setGeoTargetsFileImportPopupVisibility } from "form/tools/geo-targets-file-import"
import React from "react"
import { connect } from "react-redux"
import { Popup } from "ui/components/Popup"
import { GeoTargetsImportPopupContent } from "./GeoTargetsImportPopupContent"

interface IGeoTargetsImportPopupProps {
  containerWidth: number
  fileImport: IGeoTargetsFileImport
}

export const GeoTargetsImportPopupFn = React.memo(
  ({ containerWidth, fileImport: { isSaving, geoTargetsType } }: IGeoTargetsImportPopupProps): JSX.Element => (
    <Popup
      icon={faLocationDot}
      id="geo-targets-file-import-popup"
      displayCloseIcon={!isSaving}
      title={translate(`campaign.geo-targets.${geoTargetsType}.import.upload`)}
      onClose={origin => {
        if (origin === "outside-click") {
          return
        }
        if (!isSaving) {
          setGeoTargetsFileImportPopupVisibility(false, geoTargetsType)
        }
      }}
      maxWidth={`${Math.min(GEO_TARGETS_FILE_IMPORT_POPUP_MAX_WIDTH, containerWidth)}px`}>
      <GeoTargetsImportPopupContent />
    </Popup>
  )
)

export const GeoTargetsImportPopup = connect(
  (state: IRootState): IGeoTargetsImportPopupProps => ({
    containerWidth: state.ui.container.width,
    fileImport: getGeoTargetsFileImport(state)
  })
)(GeoTargetsImportPopupFn)
